import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private darkModeKey = 'dark-mode';

  isDarkMode(): boolean {
    return localStorage.getItem(this.darkModeKey) === 'true';
  }

  enableDarkMode(): void {
    document.body.classList.add('dark-mode');
    localStorage.setItem(this.darkModeKey, 'true');
  }

  disableDarkMode(): void {
    document.body.classList.remove('dark-mode');
    localStorage.setItem(this.darkModeKey, 'false');
  }

  toggle(): void {
    this.isDarkMode() ? this.disableDarkMode() : this.enableDarkMode();
  }

  init(): void {
    if (this.isDarkMode()) {
      document.body.classList.add('dark-mode');
    }
  }
}
